import React from "react"
// import { makeStyles } from "@material-ui/core/styles"

import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"

import ListItemText from "@material-ui/core/ListItemText"
import Collapse from "@material-ui/core/Collapse"

import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"

import { Link } from "gatsby"

export default function NestedList(props) {
  const { toggleDrawer } = props
  const [open, setOpen] = React.useState(false)

  const handleClick = () => {
    setOpen(!open)
  }

  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      className="wyotest"
    >
      <ListItem button>
        <Link to="/news/">
          <ListItemText primary="News" align="center" />
        </Link>
      </ListItem>
      <ListItem button onClick={handleClick}>
        <ListItemText
          primary="Our Wineries"
          align="center"
          style={{ position: "relative" }}
        />
        {open ? (
          <ExpandLess
            style={{ color: "white", position: "absolute", right: "20px" }}
          />
        ) : (
          <ExpandMore
            style={{ color: "white", position: "absolute", right: "20px" }}
          />
        )}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button className={"fix"}>
            <Link to="/french-wines/">
              <ListItemText primary="France" align="center" />
            </Link>
          </ListItem>
          <ListItem button className={"fix"}>
            <Link to="/italy-wines/">
              <ListItemText primary="Italy" align="center" />
            </Link>
          </ListItem>
          <ListItem button className={"fix"}>
            <Link to="/spain-wines/">
              <ListItemText primary="Spain" align="center" />
            </Link>
          </ListItem>
        </List>
      </Collapse>
      <ListItem button>
        <Link to="/us-partners/">
          <ListItemText primary="Our Partners" align="center" />
        </Link>
      </ListItem>

      <ListItem button>
        <Link to="/about-us/">
          <ListItemText primary="About Us" align="center" />
        </Link>
      </ListItem>
      <ListItem button>
        <Link to="/contact/">
          <ListItemText primary="Contact Us" align="center" />
        </Link>
      </ListItem>
      <SocialIcons toggleDrawer={toggleDrawer} />
    </List>
  )
}

const SocialIcons = props => {
  const { toggleDrawer } = props

  return (
    <div className="mobileHeader flex justify-center items-center p-2">
      <a
        href={`https://www.linkedin.com/company/bruno-lafon-selection/`}
        target="_blank"
        rel="noreferrer"
      >
        <Linkedin />
      </a>
      <div className="ml-6">
        <a
          href={`https://www.instagram.com/brunolafonselection/`}
          target="_blank"
          rel="noreferrer"
        >
          <Instagram />
        </a>
      </div>

      <div className="ml-6 mt-[5px]">
        <button onClick={toggleDrawer("top", false, "search")}>
          <Search />
        </button>
      </div>
    </div>
  )
}

const Instagram = () => (
  <svg
    fill="#FFFFFF"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
  >
    {" "}
    <path d="M 8 3 C 5.243 3 3 5.243 3 8 L 3 16 C 3 18.757 5.243 21 8 21 L 16 21 C 18.757 21 21 18.757 21 16 L 21 8 C 21 5.243 18.757 3 16 3 L 8 3 z M 8 5 L 16 5 C 17.654 5 19 6.346 19 8 L 19 16 C 19 17.654 17.654 19 16 19 L 8 19 C 6.346 19 5 17.654 5 16 L 5 8 C 5 6.346 6.346 5 8 5 z M 17 6 A 1 1 0 0 0 16 7 A 1 1 0 0 0 17 8 A 1 1 0 0 0 18 7 A 1 1 0 0 0 17 6 z M 12 7 C 9.243 7 7 9.243 7 12 C 7 14.757 9.243 17 12 17 C 14.757 17 17 14.757 17 12 C 17 9.243 14.757 7 12 7 z M 12 9 C 13.654 9 15 10.346 15 12 C 15 13.654 13.654 15 12 15 C 10.346 15 9 13.654 9 12 C 9 10.346 10.346 9 12 9 z" />
  </svg>
)

const Linkedin = () => (
  <svg
    fill="#FFFFFF"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="24px"
    height="24px"
  >
    {" "}
    <path d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M10.496,8.403 c0.842,0,1.403,0.561,1.403,1.309c0,0.748-0.561,1.309-1.496,1.309C9.561,11.022,9,10.46,9,9.712C9,8.964,9.561,8.403,10.496,8.403z M12,20H9v-8h3V20z M22,20h-2.824v-4.372c0-1.209-0.753-1.488-1.035-1.488s-1.224,0.186-1.224,1.488c0,0.186,0,4.372,0,4.372H14v-8 h2.918v1.116C17.294,12.465,18.047,12,19.459,12C20.871,12,22,13.116,22,15.628V20z" />
  </svg>
)

const Search = () => (
  <svg
    fill="#FFFFFF"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
  >
    {" "}
    <path d="M 9 2 C 5.1458514 2 2 5.1458514 2 9 C 2 12.854149 5.1458514 16 9 16 C 10.747998 16 12.345009 15.348024 13.574219 14.28125 L 14 14.707031 L 14 16 L 19.585938 21.585938 C 20.137937 22.137937 21.033938 22.137938 21.585938 21.585938 C 22.137938 21.033938 22.137938 20.137938 21.585938 19.585938 L 16 14 L 14.707031 14 L 14.28125 13.574219 C 15.348024 12.345009 16 10.747998 16 9 C 16 5.1458514 12.854149 2 9 2 z M 9 4 C 11.773268 4 14 6.2267316 14 9 C 14 11.773268 11.773268 14 9 14 C 6.2267316 14 4 11.773268 4 9 C 4 6.2267316 6.2267316 4 9 4 z" />
  </svg>
)
